var EHDI = EHDI || Object.create(null);

EHDI.component = EHDI.component || Object.create(null);

EHDI.component.ElementsContainer = function( reelDown ) {
    EHDI.aka.Container.call(this);
	
    var _this = this;
    var _reelDown = reelDown;
    
    var _groundObjects = new EHDI.aka.Container();
    var _airObjects = new EHDI.aka.Container();
    
    _this.addChild( _groundObjects );
    _this.addChild( _airObjects );
    
    // for now to check if rod equip anim happened
    var _rodEquipped = false;
    
    // create water area
    var _waterArea;
    
    // create dock
    var _coast, 
        _coastWave1, _coastWave2, 
        _dockWave1, _dockWave2,
        _dockWave1Timeline, _dockWave2Timeline;
    
    // create fish
    var _loopIndex = 0;
    var _fishGroup = [];
    
    // create frogs
    var _frogVisible = false,
        _frogTimer = 0,
        _frogSpawnThresh = EHDI.NumberUtil.randomRange( 6, 15 ),
        _frogGroup = [];
    
	// create rocks
    var _rockGroup = [];
    
	// create dragonflies
	var _bugsArma;
    var _bugsSpr;
    
    var _splashArma;
    var _splashSpr;
    
    var _arrowIcon, _arrowTimeline;
    var _notifIcon;
    var _catchRays;
    var _caughtFish;
    
	var _dragonFlyGroup = [];
    var _lilyPadGroup = [];
    
    var createWaterArea = function(){
        _waterArea = new EHDI.aka.Sprite( EHDI.displays.TextureRectangle( 0x000000, EHDI.screen.viewWidth, EHDI.screen.viewHeight ) );
        _waterArea.alpha = 0;
        _groundObjects.addChild( _waterArea );
        _waterArea.interactive = true;
        _waterArea.touchstart = _waterArea.mousedown = onWaterTapped;
    }
    
    var createDock = function(){
        _coast = new EHDI.aka.Sprite( EHDI.Assets.images["back_bg"] );
        _coast.anchor.set(0.5, 0);
        _coast.position.x = EHDI.screen.viewWidth * 0.5;
        _groundObjects.addChild(_coast);
        
        _coast.interactive = true;
        _coast.hitArea = new PIXI.Polygon( 
            [_coast.width * -0.5, 0, 
            _coast.width * 0.5, 0,
            _coast.width * 0.5, _coast.height * 0.98,
            _coast.width * -0.01, _coast.height * 0.26,
            _coast.width * -0.26, _coast.height * 0.26,
            _coast.width * -0.5, _coast.height * 0.94]
        );
        
        _coastWave1 = new EHDI.aka.Sprite( EHDI.Assets.images["coast_wave1"] );
        _coastWave1.anchor.set(0.5, 0.5);
        _coastWave1.position.set( _coast.width * 0.123, _coast.height * 0.455 );
        _coast.addChild(_coastWave1);
        
        _coastWave2 = new EHDI.aka.Sprite( EHDI.Assets.images["coast_wave2"] );
        _coastWave2.anchor.set(0.5, 0.5);
        _coastWave2.position.set( _coast.width * 0.5, _coast.height * 1.1 );
        _coast.addChild(_coastWave2);
        
        _dockWave1 = new EHDI.aka.Sprite( EHDI.Assets.images["dock_wave"] );
        _dockWave1.anchor.set(0.5, 0.5);
        _dockWave1.position.set( _coast.width * -0.287, _coast.height * 0.2625 );
        _dockWave1.scale.set( 0.5 );
        _dockWave1.alpha = 0;
        _coast.addChild(_dockWave1);
        
        _dockWave1Timeline = new TimelineMax( {repeat : -1, repeatDelay: 1.8, delay: 0.5} );
        _dockWave1Timeline
            .add( TweenMax.to( _dockWave1, 2, { scaleX: 1.1, scaleY: 1.1, alpha: 1, ease : Power0.easeNone } ) )
            .add( TweenMax.to( _dockWave1, 1, { scaleX: 1.6, scaleY: 1.6, alpha: 0, ease : Power0.easeNone } ) )
            .add( TweenMax.to( _dockWave1, 0.1, { scaleX: 0.5, scaleY: 0.5, alpha: 0 } ) );
        EHDI.GAME.gameScene.pauseManager.addTimelineInterrupt( _dockWave1Timeline );
        
        _dockWave2 = new EHDI.aka.Sprite( EHDI.Assets.images["dock_wave"] );
        _dockWave2.anchor.set(0.5, 0.5);
        _dockWave2.position.set( _coast.width * -0.447, _coast.height * 0.72 );
        _dockWave2.scale.set( 0.5 );
        _dockWave2.alpha = 0;
        _coast.addChild(_dockWave2);
        
        _dockWave2Timeline = new TimelineMax( {repeat : -1, repeatDelay: 2.9, delay: 3} );
        _dockWave2Timeline
            .add( TweenMax.to( _dockWave2, 2, { scaleX: 1.1, scaleY: 1.1, alpha: 1, ease : Power0.easeNone } ) )
            .add( TweenMax.to( _dockWave2, 1, { scaleX: 1.6, scaleY: 1.6, alpha: 0, ease : Power0.easeNone } ) )
            .add( TweenMax.to( _dockWave2, 0.1, { scaleX: 0.5, scaleY: 0.5, alpha: 0 } ) );
        EHDI.GAME.gameScene.pauseManager.addTimelineInterrupt( _dockWave2Timeline );
        
        //this.optionTimeline = new TimelineMax();
        //this.optionTimeline.add( "leave", "+=0" );
        //this.optionTimeline.add( TweenMax.to( curBtn1, 0.2, { y: posY, alpha: 0, delay: i * 0.1 } ), "leave" );
        //this.optionTimeline.add( TweenMax.to( curBtn2, 0.2, { y: posY, alpha: 0, delay: i * 0.1 } ), "leave" );
        //.add( TweenMax.to( this.options, 0.1, { x: "+=5", yoyo: true, repeat: 3 } ), "error" )
        //TweenMax.to(this.txtLoading, 0.6, {alpha: 0.1, repeat: -1, yoyo: true, ease: Power2.easeInOut});
    }
    
    var createFish = function(){
        for( var i = 0; i < 2; i++ ){
            var fishData = { arma: null, spr: null, isShown: true, time: 0, thresh: 0 };
            var fishArma = EHDI.GAME.dbFactory.buildArmature("fish");
            var fishSpr = fishArma.getDisplay();
            fishSpr.name = i;
            
            fishData.arma = fishArma;
            fishData.spr = fishSpr;
            fishData.thresh = EHDI.NumberUtil.randomRange( 6, 15 );
            
            switch(i){
                case 0: fishSpr.position.set( EHDI.screen.viewWidth * 0.787, EHDI.screen.viewHeight * 0.48 ); break;
                //case 1: fishSpr.position.set( EHDI.screen.viewWidth * 0.76, EHDI.screen.viewHeight * 0.35 ); break;
                case 1: fishSpr.position.set( EHDI.screen.viewWidth * 0.165, EHDI.screen.viewHeight * 0.76 ); break;
            }
            _groundObjects.addChild( fishSpr );
            fishSpr.touchstart = fishSpr.mousedown = onFishTapped;
            fishSpr.hitArea = new PIXI.Rectangle( -40, -40, 80, 60 );
            fishSpr.interactive = true;
            
            dragonBones.WorldClock.clock.add( fishArma );
            fishArma.animation.gotoAndPlay("idle", -1, -1, 0);
            _fishGroup.push( fishData );
        }
    }
        
    var createFrogs = function(){
        for( var i = 0; i < 2; i++ ){
            var frogData = { arma: null, spr: null };
            var frogArma = EHDI.GAME.dbFactory.buildArmature("frog");
            var frogSpr = frogArma.getDisplay();
            frogSpr.name = i;
            
            frogData.arma = frogArma;
            frogData.spr = frogSpr;
            
            switch(i){
                case 0: frogSpr.position.set( EHDI.screen.viewWidth * 0.275, EHDI.screen.viewHeight * 0.24 ); break;
                case 1: frogSpr.position.set( EHDI.screen.viewWidth * 0.856, EHDI.screen.viewHeight * 0.77 ); break;
            }
            _groundObjects.addChild( frogSpr );
            frogSpr.touchstart = frogSpr.mousedown = onFrogTapped;
            frogSpr.interactive = true;
            
            dragonBones.WorldClock.clock.add( frogArma );
            frogArma.animation.gotoAndPlay("idle_empty", -1, -1, 0);
            _frogGroup.push( frogData );
        }
    }
    
    var createRocks = function(){
        var rockArma = EHDI.GAME.dbFactory.buildArmature("rock");
        var rockSpr = rockArma.getDisplay();
        rockSpr.position.set( EHDI.screen.viewWidth * 0.84, EHDI.screen.viewHeight * 0.34 );
        rockSpr.interactive = true;
        _groundObjects.addChild( rockSpr );
        
        dragonBones.WorldClock.clock.add( rockArma );
        rockArma.animation.gotoAndPlay("idle", -1, -1, 0);
        _rockGroup.push( rockArma );
    }
    
    var createLilyPads = function(){
        
    }
    
    var createDragonFlies = function(){
        for( var i = 0; i < 5; i++ ){
            var curDragonfly = new EHDI.component.DragonflyObject();
            var startPos = { x: 0, y: 0 };
            switch(i){
                case 0: 
                    startPos.x = EHDI.screen.viewWidth * 0.4; 
                    startPos.y = EHDI.screen.viewHeight * 0.14; 
                    break;
                case 1: 
                    startPos.x = EHDI.screen.viewWidth * 0.1; 
                    startPos.y = EHDI.screen.viewHeight * 0.31; 
                    break;
                case 2: 
                    startPos.x = EHDI.screen.viewWidth * 0.775; 
                    startPos.y = EHDI.screen.viewHeight * 0.36; 
                    break;
                case 3: 
                    startPos.x = EHDI.screen.viewWidth * 0.2; 
                    startPos.y = EHDI.screen.viewHeight * 0.645; 
                    break;
                case 4: 
                    startPos.x = EHDI.screen.viewWidth * 0.91; 
                    startPos.y = EHDI.screen.viewHeight * 0.73; 
                    break;
            }
            curDragonfly.setStartPos( startPos.x, startPos.y );
            
            _airObjects.addChild( curDragonfly );
            _dragonFlyGroup.push( curDragonfly );
        }
    }
    
    var createBugs = function(){
        _bugsArma = EHDI.GAME.dbFactory.buildArmature("bugs");
        _bugsSpr = _bugsArma.getDisplay();
        _bugsSpr.position.set( EHDI.screen.viewWidth * 0.44, EHDI.screen.viewHeight * 0.725 );
        _groundObjects.addChild( _bugsSpr );
        
        _bugsSpr.interactive = true;
        _bugsSpr.touchstart = _bugsSpr.mousedown = _reelDown;
        
        dragonBones.WorldClock.clock.add( _bugsArma );
        _bugsArma.animation.gotoAndPlay("1_idle_boat", -1, -1, 0);
    }
    
    var createResult = function(){
        _catchRays = new EHDI.aka.Sprite( EHDI.Assets.images["WB_ingame_starburst"] );
        _catchRays.anchor.set( 0.5, 0.5 );
        _catchRays.scale.set( 0.35 );
        _catchRays.visible = false;
        _airObjects.addChild( _catchRays );
        TweenMax.to( _catchRays, 8, { rotation: 2 * Math.PI, ease:Linear.easeNone, repeat: -1 } );
        
        _caughtFish = new EHDI.aka.Sprite( EHDI.Assets.images[ "clownfish" ] );
        // TODO - change this scale cause the fish right now is currently too big
        //_caughtFish.scale.set( 0.5 );
        _caughtFish.scale.set( 0.4 );
        _caughtFish.anchor.set( 0.5, 0.2 );
        // TODO - this position should be in relation to the bugs' asset position
        //_caughtFish.position.set( EHDI.screen.viewWidth * 0.602, EHDI.screen.viewHeight * 0.44 );
        _caughtFish.position.x = _bugsSpr.position.x + _bugsSpr.width * 0.425;
        _caughtFish.position.y = _bugsSpr.position.y - _bugsSpr.height * 0.42;
        
        _caughtFish.visible = false;
        _airObjects.addChild( _caughtFish );
        
        _splashArma = EHDI.GAME.dbFactory.buildArmature("splash_fx");
        _splashSpr = _splashArma.getDisplay();
        _splashSpr.position.set( EHDI.screen.viewWidth * 0.61, EHDI.screen.viewHeight * 0.8 );
        _this.addChild( _splashSpr );
        
        dragonBones.WorldClock.clock.add( _splashArma );
        
        _arrowIcon = new EHDI.aka.Sprite( EHDI.Assets.images[ "arrow_notif" ] );
        _arrowIcon.anchor.set( 0.5, 0.5 );
        _arrowIcon.position.set( EHDI.screen.viewWidth * 0.37, EHDI.screen.viewHeight * 0.35 );
        _arrowIcon.visible = false;
        _airObjects.addChild( _arrowIcon );
        
        _arrowTimeline = new TimelineMax();
        _arrowTimeline.add( TweenMax.to( _arrowIcon, 0.6, { x: "+=10", y: "+=10", yoyo: true, repeat : -1 } ) );
        _arrowTimeline.paused(true);
        
        _notifIcon = new EHDI.aka.Sprite( EHDI.Assets.images[ "notif" ] );
        _notifIcon.anchor.set( 0.5, 0.5 );
        _notifIcon.position.set( EHDI.screen.viewWidth * 0.61, EHDI.screen.viewHeight * 0.35 );
        _notifIcon.visible = false;
        _airObjects.addChild( _notifIcon );
    }
    
    var onFishTapped = function(e){
        var fishData = _fishGroup[ this.name ];
        if( fishData ){
            if( fishData.arma.animation.movementID == "idle" ){
                fishData.spr.interactive = false;
                fishData.arma.animation.gotoAndPlay("click", -1, -1, 1);
                fishData.time = 0;
                fishData.thresh = EHDI.NumberUtil.randomRange( 6, 15 );
                fishData.isShown = false;
                EHDI.GAME.soundManager.playSFX( "fishing_splash_loop" )
            }
        }
    }
    
    var onFrogTapped = function(e){
        var frogData = _frogGroup[ this.name ];
        if( frogData ){
            if( frogData.arma.animation.movementID == "idle" ){
                EHDI.GAME.soundManager.playSFX("tap_frog");
                //frogData.spr.interactive = false;
                frogData.arma.animation.gotoAndPlay("click", -1, -1, 1);
                
                _frogSpawnThresh = EHDI.NumberUtil.randomRange( 7, 15 );
                _frogTimer = 0;
                _frogVisible = false;
                EHDI.GAME.achieveManager.updateFrogTapped();
            }
        }
    }
    
    var onWaterTapped = function(e){
        //_prevScrollPointerY = e.data.global.y / EHDI.GAME.scaleManager.getScale();
        var tapArma = EHDI.GAME.dbFactory.buildArmature("splash");
        var tapSpr = tapArma.getDisplay();
        tapSpr.position.x = e.data.global.x / EHDI.GAME.scaleManager.getScale();
        tapSpr.position.y = e.data.global.y / EHDI.GAME.scaleManager.getScale();
        
        if( tapSpr.position.y < _bugsSpr.position.y - _bugsSpr.height * 0.1 )
            _waterContainer.addChild( tapSpr );
        else
            _groundObjects.addChild( tapSpr );
        
        dragonBones.WorldClock.clock.add( tapArma );
        
        var splashComplete = function(){
            tapArma.removeEventListener(dragonBones.FrameEvent.COMPLETE, splashComplete);
            dragonBones.WorldClock.clock.remove(tapArma);
            
            tapSpr.destroy();
            tapArma = null;
        };
        
        tapArma.addEventListener(dragonBones.AnimationEvent.COMPLETE, splashComplete);
        tapArma.animation.gotoAndPlay("click", -1, -1, 1);
        
        EHDI.GAME.soundManager.playSFX("tap_water");
        EHDI.GAME.achieveManager.updateSplashing();
    }
    
    var bugsLoopComplete = function( event ) {
        var animName = event.animationName;
        
        if( animName.indexOf( "idle" ) !== -1 ){
            var index = parseInt( event.animationName.slice( -1 ) );
            var repeatChance = 1;
            switch( index ){
                case 1: repeatChance = 0.4; break;
                case 2: repeatChance = 0.6; break;
                case 3: repeatChance = 0; break;
                case 4: repeatChance = 0.21; break;
                case 5: repeatChance = 0.34; break;
            }

            if( Math.random() > repeatChance ){
                var newIdleIndex = index;
                do{
                    newIdleIndex = Math.floor( EHDI.NumberUtil.randomRange( 1, 6 ) );
                }while( index === newIdleIndex )
                _this.setBugsAnimation( "idle" + newIdleIndex, 0 );
            }
        }
    }
    
    var bugsEventHandler = function( event ){
        console.log( "bugs event " + event.frameLabel + " called" );
        
        if( event.frameLabel === "rod_up_end" ){
            EHDI.GAME.gameScene.startReelSession();
        }
        else if( event.frameLabel === "struggle_catch_end" ){
            _this.setCaughtFishVisible( true );
            EHDI.GAME.gameScene.showReelResults();
        }
        else if( event.frameLabel === "struggle_fail_end" || event.frameLabel === "catch_end" ){
            EHDI.GAME.gameScene.showReelResults();
        }
        else if( event.frameLabel === "cast_down" ){
            _this.setBugsAnimation( "rod_down", 1 );
        }
        else if( event.frameLabel === "notif_end_end" ){
            EHDI.GAME.gameScene.reelMissed();
        }
        else if( event.frameLabel === "cast_end" ){
            if( !_rodEquipped )
                EHDI.GAME.gameScene.resetState();
            else{
                _rodEquipped = false;
                if( EHDI.GAME.gameScene.powerIndex === 1 )  EHDI.GAME.gameScene.startPowerTimer();
                else                                        EHDI.GAME.gameScene.startPowerTimer( true );
            }
        }
        else if( event.frameLabel === "d_hat_equip_end" ){
            EHDI.GAME.gameScene.startPowerTimer();
        }
        else if( event.frameLabel === "hat_equip_end" ){
            EHDI.GAME.gameScene.startPowerTimer( true );
        }
        else if( event.frameLabel === "rod_equip_end" || event.frameLabel === "d_rod_equip_end" ){
            if( event.frameLabel.charAt(0) !== "d" ) _rodEquipped = true;
            _this.setBugsAnimation( "cast", 1 );
            EHDI.GAME.soundManager.playSFX("throw_fishing_line");
        }
    }
    
    var splashEventHandler = function( event ){
        console.log( "splash event " + event.frameLabel + " called" );
        
        if( event.frameLabel === "show_fish" ){
            _this.setCaughtFishVisible( true );
        }
    }
    
    this.update = function( dt ){
        for( _loopIndex = 0; _loopIndex < 2; _loopIndex++ ){
            if( !_fishGroup[ _loopIndex ].isShown ){
                _fishGroup[ _loopIndex ].time += dt;
                
                if( _fishGroup[ _loopIndex ].time > _fishGroup[ _loopIndex ].thresh ){
                    _fishGroup[ _loopIndex ].isShown = true;
                    _fishGroup[ _loopIndex ].spr.interactive = true;
                    _fishGroup[ _loopIndex ].arma.animation.gotoAndPlay("swim_back", -1, -1, 0);
                }
            }
        }
        
        if( !_frogVisible ){
            _frogTimer += dt;
            
            if( _frogTimer > _frogSpawnThresh ){
                EHDI.GAME.soundManager.playSFX("frog_spawn");
                _frogTimer = 0;
                _frogVisible = true;
                
                var shownFrog = _frogGroup[ Math.floor( EHDI.NumberUtil.randomRange( 0, _frogGroup.length ) ) ];
                //shownFrog.spr.interactive = true;
                shownFrog.arma.animation.gotoAndPlay("jump_back", -1, -1, 1);
            }
        }
    }
    
    this.setBugsInteractive = function( status ){
        _bugsSpr.interactive = status;
    }
    
    this.setBugsAnimation = function( anim, repeat ){
        if( _bugsArma.animation.movementID == anim ) return;
        
        anim = EHDI.GAME.gameScene.powerIndex + "_" + anim;
        console.log( "played anim is " + anim );
        _bugsArma.animation.gotoAndPlay( anim, -1, -1, repeat );
    }
    
    this.setSplashAnimation = function( anim, repeat ){
        _splashArma.animation.gotoAndPlay( anim, -1, -1, repeat );
    }
    
    this.setNotifVisible = function( status ){
        _arrowTimeline.paused( !status )
        if( status )    _arrowTimeline.restart();
        
        _arrowIcon.visible = status;
        _notifIcon.visible = status;
    }
    
    this.setNotifType = function( type ){
        if( type === 0 )    _notifIcon.texture = EHDI.Assets.images[ "notif" ];
        else                _notifIcon.texture = EHDI.Assets.images[ "notif_hard" ];
    }
    
    this.setCaughtFish = function( fish, type ){
        if( fish === null ){
            _caughtFish.texture = null;
        }
        else{
            _caughtFish.texture = EHDI.Assets.images[ fish ];
            switch( type ){
                case 0: _caughtFish.scale.set(0.4); break;
                case 1: _caughtFish.scale.set(0.75); break;
                case 2: _caughtFish.scale.set(0.8); break;
            }
        }
    }
    
    this.setCaughtFishVisible = function( status ){
        _catchRays.visible = status;
        _caughtFish.visible = status;
        
        if( status ){
            _caughtFish.position.x = _bugsSpr.position.x + _bugsSpr.width * 0.425;
            _caughtFish.position.y = _bugsSpr.position.y - _bugsSpr.height * 0.42;
            
            _catchRays.position.x = _caughtFish.position.x;
            _catchRays.position.y = _caughtFish.position.y + ( _caughtFish.height * 0.3 );
        }
    }
    
    this.updateLayerOrder = function() {
        //_this.gameLayer.children.sort(function(a,b) {
            //a.zIndex = a.zIndex || 0;
            //b.zIndex = b.zIndex || 0;
            //return a.zIndex - b.zIndex;
        _groundObjects.children.sort(function(a,b) {
            a.position.y = a.position.y || 0;
            b.position.y = b.position.y || 0;
            return a.position.y - b.position.y;
        });
    }
    
    this.onResize = function(){
        _waterArea.height = EHDI.screen.viewHeight;
        _waterArea.width = EHDI.screen.viewWidth;
        
        _coast.position.set( EHDI.screen.viewWidth * 0.5, 0 );
        
        for( _loopIndex = 0; _loopIndex < 2; _loopIndex++ ){
            var fishData = _fishGroup[ _loopIndex ];
            var fishSpr = fishData.spr;
            
            var frogData = _frogGroup[ _loopIndex ];
            var frogSpr = frogData.spr;
            
            switch( _loopIndex ){
                case 0: 
                    fishSpr.position.set( EHDI.screen.viewWidth * 0.787, EHDI.screen.viewHeight * 0.48 );
                    frogSpr.position.set( EHDI.screen.viewWidth * 0.275, EHDI.screen.viewHeight * 0.24 ); 
                    break;
                    
                case 1: 
                    fishSpr.position.set( EHDI.screen.viewWidth * 0.165, EHDI.screen.viewHeight * 0.76 );
                    frogSpr.position.set( EHDI.screen.viewWidth * 0.856, EHDI.screen.viewHeight * 0.77 ); 
                    break;
            }
        }
        
        _bugsSpr.position.set( EHDI.screen.viewWidth * 0.44, EHDI.screen.viewHeight * 0.725 );
        _caughtFish.position.x = _bugsSpr.position.x + _bugsSpr.width * 0.425;
        _caughtFish.position.y = _bugsSpr.position.y - _bugsSpr.height * 0.42;
        _splashSpr.position.set( EHDI.screen.viewWidth * 0.61, EHDI.screen.viewHeight * 0.8 );
        _arrowIcon.position.set( EHDI.screen.viewWidth * 0.37, EHDI.screen.viewHeight * 0.35 );
        _arrowTimeline.restart();
        _notifIcon.position.set( EHDI.screen.viewWidth * 0.61, EHDI.screen.viewHeight * 0.35 );
    }
    
    this.dispose = function(){
        _bugsArma.removeEventListener(dragonBones.AnimationEvent.LOOP_COMPLETE, bugsLoopComplete);
        _bugsArma.removeEventListener(dragonBones.FrameEvent.ANIMATION_FRAME_EVENT, bugsEventHandler);
        _splashArma.removeEventListener(dragonBones.FrameEvent.ANIMATION_FRAME_EVENT, splashEventHandler);
        
        EHDI.GAME.gameScene.pauseManager.removeTimelineInterrupt( _dockWave1Timeline );
        EHDI.GAME.gameScene.pauseManager.removeTimelineInterrupt( _dockWave2Timeline );
        
        for( var i = 0; i < _dragonFlyGroup.length; i++ ){
            _dragonFlyGroup[i].dispose();
        }
        
        for( var i = 0; i < _frogGroup.length; i++ ){
            var curData = _frogGroup[i];
            dragonBones.WorldClock.clock.remove( curData.arma );
        }
    }
    
    createWaterArea();
    createDock();
    createFish();
    createFrogs();
    createRocks();
    createLilyPads();
    createDragonFlies();
    createBugs();
    
    var _waterContainer = new EHDI.aka.Container();
    _waterContainer.position.y = _bugsSpr.position.y - 5;
    _groundObjects.addChild( _waterContainer );
    
    createResult();
    _this.updateLayerOrder();
    
    _waterContainer.position.y = 0;
    
    _bugsArma.addEventListener(dragonBones.AnimationEvent.LOOP_COMPLETE, bugsLoopComplete);
    _bugsArma.addEventListener(dragonBones.FrameEvent.ANIMATION_FRAME_EVENT, bugsEventHandler);
    _splashArma.addEventListener(dragonBones.FrameEvent.ANIMATION_FRAME_EVENT, splashEventHandler);
}

EHDI.component.ElementsContainer.prototype = Object.create(EHDI.aka.Container.prototype);